import { I18n } from '@aws-amplify/core';
import { message } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/utils/query-keys';
import { BeraV2Service } from '@/infra/services/bera-v2';

export interface DeleteBeraTlidParams {
	id: string;
	organization_id: string;
	company_id: string;
}

const Service = BeraV2Service.getInstance();

export function useDeleteBeraTlid() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: DeleteBeraTlidParams) => Service.removeReport(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_BERA_SUMMARY_RESULT_V2]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_BERA_JOB_SUMMARY_LIST]);
			message.success(I18n.get('TLID deleted successfully'));
		},
		onError: () => {
			message.error(I18n.get('Failed to delete the TLID'));
		}
	});
}
